export default __webpack_public_path__ + "45d1e5f.png";